/**
 * Rishora Premium Product Page - Custom Logic
 */
document.addEventListener('DOMContentLoaded', () => {
  const variantRadios = document.querySelectorAll('variant-radios, variant-selects');
  const stickyBar = document.getElementById('RishoraStickyBar');
  const stickyThumb = document.getElementById('StickyThumb');
  const stickyPrice = document.getElementById('StickyPrice');
  const stickyVariantName = document.getElementById('StickyVariantName');
  const mainAddToCart = document.querySelector('.product-form__submit');

  // 1. Variant Carousel Logic
  if (variantRadios.length > 0) {
    variantRadios.forEach(container => {
      container.addEventListener('change', (e) => {
        const cards = container.querySelectorAll('.rishora-variant-card');
        
        cards.forEach(card => {
          const input = card.querySelector('input[type="radio"]');
          if (input && input.checked) {
            card.classList.add('is-selected');
            
            // Center the selected variant in the scroll view
            if (window.innerWidth <= 749) {
              card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
            
            // Update Sticky Bar Data
            if (stickyThumb) {
              const img = card.querySelector('.rishora-variant-image');
              if (img) stickyThumb.src = img.src;
            }
            // Price is dynamically updated by Shopify's native JS, we sync it if possible
            // A simple MutationObserver watches the main price to sync with sticky price
          } else {
            card.classList.remove('is-selected');
          }
        });

        if (stickyVariantName) {
          const selectedValues = Array.from(container.querySelectorAll('input[type="radio"]:checked')).map(radio => radio.value);
          stickyVariantName.textContent = selectedValues.join(' / ');
        }
      });

      // Initial visual state
      const checkedInput = container.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        const parentCard = checkedInput.closest('.rishora-variant-card');
        if (parentCard) {
          parentCard.classList.add('is-selected');
          if (window.innerWidth <= 749) {
            // Slight delay to ensure layout is ready
            setTimeout(() => {
              parentCard.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
            }, 100);
          }
        }
      }
    });
  }

  // 2. Sync Price MutationObserver
  const mainPrice = document.querySelector('.price .price-item--regular');
  if (mainPrice && stickyPrice) {
    const observer = new MutationObserver(() => {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    });
    observer.observe(mainPrice, { childList: true, characterData: true, subtree: true });
  }

  // 3. Sticky Purchase Bar Visibility (IntersectionObserver)
  if (mainAddToCart && stickyBar && window.innerWidth <= 749) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // Main button is out of view, show sticky bar
          stickyBar.classList.add('is-visible');
          document.body.classList.add('has-sticky-bar-visible');
        } else {
          // Main button is in view, hide sticky bar
          stickyBar.classList.remove('is-visible');
          document.body.classList.remove('has-sticky-bar-visible');
        }
      });
    }, { threshold: 0.1 }); // Trigger when button is 90% hidden

    observer.observe(mainAddToCart);
  }

  // 4. Master Button State Synchronization (Double-Click & Sold Out Prevention)
  const stickyBtn = document.querySelector('.rishora-sticky-btn');
  if (mainAddToCart && stickyBtn) {
    const syncButtonState = () => {
      // Mirror disabled / loading states natively from Dawn's engine
      const isDisabled = mainAddToCart.hasAttribute('disabled') || mainAddToCart.getAttribute('aria-disabled') === 'true';
      if (isDisabled) {
        stickyBtn.setAttribute('disabled', 'disabled');
      } else {
        stickyBtn.removeAttribute('disabled');
      }
      
      // Mirror Sold Out / Unavailable text dynamically
      const mainTextSpan = mainAddToCart.querySelector('span');
      if (mainTextSpan) {
        // If Dawn is loading, it might hide the span, but text remains intact.
        const newText = mainTextSpan.textContent.trim();
        if (newText && stickyBtn.textContent.trim() !== newText) {
          stickyBtn.textContent = newText;
        }
      }
    };
    
    // Execute initial sync payload
    syncButtonState();
    
    // Bind ultra-fast observer to intercept native Dawn DOM manipulations
    const btnObserver = new MutationObserver(syncButtonState);
    btnObserver.observe(mainAddToCart, { attributes: true, childList: true, subtree: true, characterData: true });
  }
});
